const API = process.env.SVELTE_APP_API || 'api';

export { API as default };
